import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseProductivityRiskKPIProvider } from 'components/widgets/ProductivityRiskKPI/ProductivityRiskKPI.provider';
import { getValueClassName } from 'components/widgets/ProductivityRiskKPI/ProductivityRiskKPI.utils';

interface Props {
    api: UseProductivityRiskKPIProvider['api'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode?: WidgetViewMode;
}

export const useProductivityRiskKPILogic = ({ api, setIsPayloadReady, widgetViewMode }: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getProductivityRiskKPI.payload;
        if (!currentPayload) return;
        if (
            currentPayload.compareVersionId === undefined ||
            currentPayload.latestVersionId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
    const value = api.getProductivityRiskKPI.instance.data?.value;
    const threshold = api.getProductivityRiskKPI.instance.data?.threshold;

    const calculatedValue = api.getProductivityRiskKPI.instance.data?.value
        ? api.getProductivityRiskKPI.instance.data?.value
        : 'N/A';

    return {
        logic: {
            valueClassName: getValueClassName(value, threshold),
            calculatedValue,
        },
    };
};
